import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query'

import { getGisSites } from '../api/gisApi'

import type { GisScope } from '../api/types'

/**
 * Map markers, windowed by the panel scope (date-filter handoff §6): the period + entity + custom
 * range ARE in the key, so markers refetch and re-color when the date filter changes — matching the
 * choropleth. Search/clustering stays client-side. `keepPreviousData` keeps the existing markers on
 * screen during a scope switch instead of flashing empty. Backend TTL-caches for 300s, so a 5-minute
 * staleTime matches that without over-refetching markers that change slowly.
 */
export const gisSitesQueryOptions = (scope: GisScope) =>
  queryOptions({
    queryKey: ['gis', 'sites', scope.period, scope.entityId ?? null, scope.dateFrom ?? null, scope.dateTo ?? null] as const,
    queryFn: () => getGisSites(scope),
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  })

export function useGisSites(scope: GisScope) {
  return useQuery(gisSitesQueryOptions(scope))
}
